// use-show-reminder-icon.ts
// Liefert true, wenn für den aktuellen Pfad Reminder-Icons angezeigt werden sollen
export function useShowReminderIcon(path: string) {
  return [
    /^\/app\/contacts\/(\d+)/,
    /^\/app\/art\/activities\/(\d+)/,
    /^\/app\/contracts\/contracts\/(\d+)/,
    /^\/app\/art\/productions\/(\d+)/,
  ].some((regex) => regex.test(path))
}
